import {authService} from "@/services/AuthService";

export default (to, next, store) => {

    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
    const loggedIn = !!authService.getToken()

    if (!loggedIn && onlyWhenLoggedOut) {
        return next()
    } else {
        return next({
            name: 'order-today'
        })
    }
}
